import React from 'react';
import styled from 'styled-components';
import { ReactComponent as CheckboxCheckedIcon } from './checkbox-checked.svg';

interface CheckboxOptionProps {
  checked: boolean;
  onValueChanged(v: boolean): void;
  label: string;
  disabled?: boolean;
}

const CheckboxOption: React.FC<CheckboxOptionProps> = ({ checked, onValueChanged, label, disabled = false }) => {
  const id = React.useId();
  return (
    <Container data-disabled={disabled}>
      <Label htmlFor={id} aria-disabled={disabled}>
        <NativeCheckbox
          id={id}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onValueChanged(e.target.checked)}
        />
        <Box data-checked={checked}>{checked && <Tick />}</Box>
        <Text>{label}</Text>
      </Label>
    </Container>
  );
};

export default CheckboxOption;

const Container = styled.div`
  min-height: 44px;
  background-color: #e751131a;
  border-radius: 6px;

  &[data-disabled='true'] {
    opacity: 0.6;
    pointer-events: none;
  }
`;

const Label = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding-top: 13px;
  padding-left: 12px;

  &[aria-disabled='true'] {
    cursor: default;
  }
`;

const NativeCheckbox = styled.input`
  display: none;
`;

const Box = styled.div`
  width: 14px;
  height: 14px;
  border: 1px solid ${({ theme }) => theme.colors.primaryOrange};
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  transition: all 0.15s ease;

  &[data-checked='true'] {
    background: #e75113;
  }

  ${Label}[aria-disabled="true"] & {
    border-color: #ccc;
    background: #f2f2f2;
  }
`;

const Tick = styled(CheckboxCheckedIcon)`
  width: 16px;
  height: 16px;
  stroke: white;
  stroke-width: 2;
  fill: none;
`;

const Text = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.primaryBlack};
  font-family: Inter, sans-serif;

  ${Label}[aria-disabled="true"] & {
    color: #888;
  }
`;
